<template>
  <div class="button-edit py-2 px-4">
    <v-select hide-details :items="socials" item-text="name" item-value="key" v-model="form.icon" :label="$t('socialedit_social_media_website')"></v-select>
    <v-text-field class="pt-5" hide-details :placeholder="$t('socialedit_display_text')" v-model="form.content" :label="$t('socialedit_display_text')"></v-text-field>
    <!-- <v-text-field class="pt-5" hide-details  @input="updateUrl()" v-model="btnUrl" label="Link"></v-text-field> -->

    <rich-text-input :placeholder="$t('socialedit_link_placeholder')" :content.sync="form.url" mode="url" :json.sync="editorContentJson" :label="$t('socialedit_link')"></rich-text-input>

  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'

export default {
  name: 'SocialEdit',
  props: ['content', 'url', 'icon'],
  components: {
    'rich-text-input': RichTextInput
  },
  data () {
    return {
      form: {
        content: '',
        url: '',
        icon: ''
      },
      editorContentJson: {},
      socials: [
        { name: 'Instagram', key: 'instagram' },
        { name: 'X', key: 'tw' },
        { name: 'TikTok', key: 'tiktok' },
        { name: 'Facebook', key: 'fb' },
        { name: 'Youtube', key: 'yt' },
        { name: 'Linkedin', key: 'linkedin' },
        { name: 'Other', key: 'logo' }
      ]
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }

    this.form.url = this.url
    if (typeof this.form.url !== 'string') {
      this.form.url = ''
    }

    this.form.icon = this.icon
  }
}
</script>

<style lang="sass">

</style>
